export default __webpack_public_path__ + "static/media/tab_logo.dca8655d.png";